
/**
 * Calculate days since last order from the date string
 * @param lastOrderDate Order date string (can be in various formats)
 * @returns Number of days since order
 */
export const getDaysSinceOrder = (lastOrderDate: string): number => {
  if (!lastOrderDate || lastOrderDate === 'Never') return 1000;
  
  try {
    const orderDate = new Date(lastOrderDate);
    const now = new Date();
    return Math.floor((now.getTime() - orderDate.getTime()) / (1000 * 60 * 60 * 24));
  } catch (err) {
    return 1000;
  }
};

/**
 * Categorize order recency for styling/display purposes
 * @param lastOrderDate Order date string
 * @returns Recency category: 'recent', 'old' or 'none'
 */
export const getOrderRecency = (lastOrderDate: string): 'recent' | 'old' | 'none' => {
  if (!lastOrderDate || lastOrderDate === 'Never') return 'none';
  
  try {
    const daysSince = getDaysSinceOrder(lastOrderDate);
    return daysSince <= 30 ? 'recent' : 'old';
  } catch (err) {
    return 'none';
  }
};

/**
 * Format a phone number for display
 * @param phone Raw phone number
 * @returns Formatted phone number
 */
export const formatPhoneNumber = (phone: string): string => {
  if (!phone) return '';
  
  // Remove non-numeric characters
  const numbers = phone.replace(/\D/g, '');
  
  // Check for US format (10 digits)
  if (numbers.length === 10) {
    return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(6)}`;
  }
  
  // International format
  if (numbers.length > 10) {
    return `+${numbers.slice(0, numbers.length - 10)} (${numbers.slice(-10, -7)}) ${numbers.slice(-7, -4)}-${numbers.slice(-4)}`;
  }
  
  return phone;
};
